module.exports = __webpack_public_path__ + "static/media/ios-female.0331d982.svg";